<template>
  <div class="module">
    <div class="module__title"></div>
    <div class="module__content">
      <div class="icon-list">
        <div class="icon-item">
          <div class="icon icon-wechat" @click="openCode('wechat')"></div>
          <div class="name">官方微信</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-weibo" @click="openLink('weibo')"></div>
          <div class="name">官方微博</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-taptap" @click="openLink('taptap')"></div>
          <div class="name">TapTap</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-hykb" @click="openLink('hykb')"></div>
          <div class="name">好游快爆</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-bilibili" @click="openLink('bilibili')"></div>
          <div class="name">哔哩哔哩</div>
        </div>
        <div class="icon-item">
          <div class="icon icon-xhs" @click="openLink('xhs')"></div>
          <div class="name">小红书</div>
        </div>
      </div>
    </div>
    <pc-dialog :title="dialogTitle" :visible.sync="dialogVisible" @confirm="handleDialogConfirm">
      <template #content>
        <div class="code-box">
          <div class="code"></div>
          <div class="description">扫码关注微信公众号</div>
        </div>
      </template>
    </pc-dialog>
  </div>
</template>

<script>
import PcDialog from '@/views/pc/components/dialog/Index.vue'

import socialMixins from '@/mixins/home/socialMixins.js'

export default {
  name: 'PcHomeSocial',
  mixins: [socialMixins],
  components: {
    PcDialog,
  },
}
</script>

<style lang="scss" scoped>
.module {
  height: 691px;

  &__title {
    background-position: center -1152px;
  }

  &__content {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden;
    margin-top: 90px;
    width: 1200px;
  }
}

.icon-list {
  display: flex;
  justify-content: space-between;

  .icon-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 136px;
    height: 190px;

    .icon {
      width: 136px;
      height: 136px;
      background: url('~@/assets/img/common/social_icon.png') no-repeat;
      border-radius: 50%;
      cursor: pointer;

      &-wechat {
        background-position: 0 0;
      }
      &-weibo {
        background-position: -136px 0;
      }
      &-bilibili {
        background-position: -272px 0;
      }
      &-taptap {
        background-position: 0 -136px;
      }
      &-hykb {
        background-position: -136px -136px;
      }
      &-xhs {
        background-position: -272px -136px;
      }
    }

    .name {
      font-size: 25px;
      font-family: Noto Serif SC;
      font-weight: bold;
      color: #584c45;
    }
  }
}

.code-box {
  margin: 0 auto 40px;
  width: 260px;
  height: 298px;
  background: #fff;
  border: solid 1px #e5d6cb;

  .code {
    width: 258px;
    height: 258px;
    background: url('~@/assets/img/common/wechat.jpg') no-repeat;
  }

  .description {
    text-align: center;
    line-height: 25px;
    font-size: 25px;
    color: #000;
  }
}
</style>